import type { ApiResponse } from '@klaro7/shared-types';

import api from '@/lib/api';

export interface ReferralInfo {
  referralCode: string;
  shareLink: string;
  referredCount: number;
}

export async function getMyReferral(): Promise<ReferralInfo> {
  const response = await api.get<ApiResponse<ReferralInfo>>('/referrals/me');
  return response.data.data;
}
